import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { getMonth, newDate, getYear, setMonth, isAfter, isBefore, isSameMonth, getStartOfMonth } from '../../utils/date-fns';
import Context from '../../context';
import useRangeCls from '../../hooks/use-range-cls';
export var monthsNumToText = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月', '13月'];
var monthsThreeColumns = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]];

function Month(props) {
  var context = useContext(Context);
  var prefixCls = context.prefixCls,
      dateValue = context.dateValue,
      viewDate = context.viewDate,
      onSelect = context.onSelect,
      onDateMouseEnter = context.onDateMouseEnter,
      onDateMouseLeave = context.onDateMouseLeave,
      rangeValue = context.rangeValue,
      panelPosition = context.panelPosition,
      hoverRangedValue = context.hoverRangedValue;
  var disabledDate = props.disabledDate;

  var _dateValue;

  if (panelPosition) {
    _dateValue = rangeValue;
  } else {
    _dateValue = dateValue;
  }

  var hasFindSelected = false;
  var hasFindToday = false;

  var getMonthSelected = function getMonthSelected(month) {
    if (hasFindSelected) return false;

    if (Array.isArray(_dateValue)) {
      return _dateValue[0] && getMonth(_dateValue[0]) === month && getYear(_dateValue[0]) === getYear(viewDate) || _dateValue[1] && getMonth(_dateValue[1]) === month && getYear(_dateValue[1]) === getYear(viewDate);
    } else {
      if (_dateValue && getMonth(_dateValue) === month && getYear(_dateValue) === getYear(viewDate)) {
        hasFindSelected = true;
        return true;
      }

      return false;
    }
  };

  var getMonthToday = function getMonthToday(month) {
    if (hasFindToday) return false;

    if (getYear(viewDate) === getYear(newDate()) && month === getMonth(newDate())) {
      hasFindToday = true;

      if (Array.isArray(_dateValue)) {
        return _dateValue[0] ? getMonth(_dateValue[0]) !== month : _dateValue[1] ? getMonth(_dateValue[1]) !== month : true;
      } else {
        return _dateValue ? getMonth(_dateValue) !== month : true;
      }
    }
  };

  var getMonthClassNames = function getMonthClassNames(i) {
    var _classnames;

    return classnames("".concat(prefixCls, "-month-text"), (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "-month-text-selected"), getMonthSelected(i)), _defineProperty(_classnames, "".concat(prefixCls, "-month-text-today"), getMonthToday(i)), _classnames));
  };

  var getRangeCls = useRangeCls({
    prefixCls: prefixCls,
    rangeValue: rangeValue,
    hoverRangedValue: hoverRangedValue,
    isRange: !!panelPosition,
    isAfterStart: function isAfterStart(date, rangedValue) {
      return rangedValue[0] ? isAfter(getStartOfMonth(date), getStartOfMonth(rangedValue[0])) : false;
    },
    isBeforeEnd: function isBeforeEnd(date, rangedValue) {
      return rangedValue[1] ? isBefore(getStartOfMonth(date), getStartOfMonth(rangedValue[1])) : false;
    },
    isStart: function isStart(date, rangedValue) {
      return rangedValue[0] ? isSameMonth(date, rangedValue[0]) : false;
    },
    isEnd: function isEnd(date, rangedValue) {
      return rangedValue[1] ? isSameMonth(date, rangedValue[1]) : false;
    }
  });

  var handleClick = function handleClick(date) {
    if (!(disabledDate && disabledDate(date))) {
      onSelect(date, 'mouse');
    }
  };

  var renderMonthItem = function renderMonthItem(i) {
    var monthsText = monthsNumToText[i];
    return /*#__PURE__*/React.createElement("span", {
      className: getMonthClassNames(i)
    }, monthsText);
  };

  var renderMonth = function renderMonth() {
    var monthLayout = monthsThreeColumns;
    var monthLineCls = classnames("".concat(prefixCls, "-month-line"));
    return _mapInstanceProperty(monthLayout).call(monthLayout, function (month, i) {
      return /*#__PURE__*/React.createElement("div", {
        className: monthLineCls,
        key: i
      }, _mapInstanceProperty(month).call(month, function (m, j) {
        var month = setMonth(viewDate, m);
        var _props = {
          onClick: function onClick() {
            return handleClick(month);
          },
          onMouseEnter: function onMouseEnter() {
            if (onDateMouseEnter && !(disabledDate && disabledDate(month))) {
              onDateMouseEnter(month);
            }
          },
          onMouseLeave: function onMouseLeave() {
            if (onDateMouseLeave) {
              onDateMouseLeave();
            }
          }
        };
        var monthItemCls = classnames("".concat(prefixCls, "-month-item"), _defineProperty({}, "".concat(prefixCls, "-month-item-disabled"), disabledDate && disabledDate(month)), getRangeCls(month));
        return /*#__PURE__*/React.createElement("div", _extends({
          className: monthItemCls,
          key: j
        }, _props), renderMonthItem(m));
      }));
    });
  };

  var monthCls = classnames("".concat(prefixCls, "-month"));
  var monthWarpperCls = classnames("".concat(prefixCls, "-month-warpper"));
  return /*#__PURE__*/React.createElement("div", {
    className: monthCls
  }, /*#__PURE__*/React.createElement("div", {
    className: monthWarpperCls
  }, renderMonth()));
}

export default Month;